import { http_get, http_put } from './helpers';
import { version } from './config';
import { NewsItem } from './types';

// 获取全部消息
export const getSitMessages = http_get<
    {
        Status: number | null;
        SkipCount: number;
        MaxResultCount: number;
        Category: number | string;
    },
    {
        totalCount: number;
        items: NewsItem[] | [];
    }
>(`/api/v${version}/f/SiteMessages`);

// 阅读某条消息
export const readMessages = http_put<
    { id: string },
    any
>(`/api/v${version}/f/SiteMessages/{id}/Read`);

// 阅读全部消息
export const readMessagesAll = http_put<
    void,
    any
>(`/api/v${version}/f/SiteMessages/ReadAll`);
